/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic';
import {ROUTE_SEARCH} from '@constants';
import {openUrl, deferTask} from '@jobseeker/common-core/utils/common';

const DynamicSearchOverlay = dynamic(
  () => import('@jobseeker/client-harness/components/SearchHarness')
);

const InjectSearchOverlay = ({isSearchEnabled}: {isSearchEnabled: boolean}) => {
  const handleSearchSubmit = (
    keyword: string,
    location: string,
    experience: {
      minexp: number;
      maxexp: number;
    },
    posting?: string[],
    filterData?: any,
    category?: string,
    searchType?: any,
    method?: string
  ) => {
    deferTask(() => {
      const queryObject: any = {
        loc: location,
        minexp: experience?.minexp?.toString() ?? '',
        maxexp: experience?.maxexp?.toString() ?? '',
        posting: posting?.length ? posting?.join() ?? '' : '',
        category: category ?? '',
        searchType: searchType ?? '',
        method: method ?? '',
      };
      if (filterData?.industry) {
        queryObject.industry = filterData?.industry.join(',');
      }
      const queryString = new URLSearchParams(queryObject).toString();
      let url = `${ROUTE_SEARCH}/${keyword}-jobs?${queryString}`;
      if (searchType == 2) {
        url = `/courses?${queryString}&keyword=${keyword}`;
      }
      if (searchType == 1) {
        url = `/company?${queryString}&keyword=${keyword}`;
      }
      openUrl(url, '_self');
    });
  };

  return isSearchEnabled ? (
    <DynamicSearchOverlay
      isSearchEnabled={isSearchEnabled}
      handleSearchSubmit={handleSearchSubmit}
    />
  ) : (
    <></>
  );
};

export default InjectSearchOverlay;
